var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 76.9 76.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2,.cls-3{fill:none;stroke-miterlimit:10;}.cls-2{stroke:#fff;stroke-width:0.9px;}.cls-3{stroke:#018b9d;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Time") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 38.45,
    cy: 38.45,
    r: 32.67
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 38.45,
    cy: 38.45,
    r: 38
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "38.32 27 38.32 39.38 43.89 44.95"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 20.98,
    y1: 39.38,
    x2: 23.46,
    y2: 39.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 53.18,
    y1: 39.38,
    x2: 55.65,
    y2: 39.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 38.32,
    y1: 56.72,
    x2: 38.32,
    y2: 54.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 38.32,
    y1: 24.52,
    x2: 38.32,
    y2: 22.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M38.32,58.57a19.19,19.19,0,0,0,0-38.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M38.32,58.57A19.2,19.2,0,0,1,22.69,28.23l3.48-3.48"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "26.55 31.33 26.55 24.52 19.74 24.52"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/Time.a2543c401a6976ad9323ac9bbc62682b.svg";
export { ForwardRef as ReactComponent };